import { Box, Paper, Stack, Typography } from '@mui/material'
import { DOCK_MAGNIFICATION_MARKS, DOCK_SIZE_MARKS } from '@/components/Settings/appearanceConstants'
import appearanceStyles from '@/components/Settings/AppearanceSettingsContent.module.scss'
import SettingsSliderControl from '@/components/Settings/SettingsSliderControl'
import SettingsSectionIntro from '@/components/Settings/SettingsSectionIntro'
import { getSettingsSectionIntro } from '@/components/Settings/settingsSectionDescriptions'
import shared from '@/components/Settings/settingsShared.module.scss'

/**
 * @param {{
 *   headingId: string, paperSingle: string,
 *   dockSize: number, onDockSizeChange: (v: number) => void,
 *   dockMagnification: number, onDockMagnificationChange: (v: number) => void,
 * }} props
 */
export function AppearanceDockSection({ headingId, paperSingle, dockSize, onDockSizeChange, dockMagnification, onDockMagnificationChange }) {
  return (
    <Stack component="section" spacing={1.25} className={shared.preferenceSection} aria-labelledby={headingId}>
      <SettingsSectionIntro headingId={headingId} lines={getSettingsSectionIntro('dock')} />
      <Paper elevation={0} className={paperSingle}>
        <Box className={appearanceStyles.dockSliders}>
          <Box className={appearanceStyles.dockSliderBlock}>
            <Typography component="p" variant="subtitle2" className={appearanceStyles.dockSliderTitle}>Size</Typography>
            <SettingsSliderControl value={dockSize} onChange={onDockSizeChange} marks={DOCK_SIZE_MARKS} aria-label="Dock size" />
          </Box>
          <Box className={appearanceStyles.dockSliderBlock}>
            <Typography component="p" variant="subtitle2" className={appearanceStyles.dockSliderTitle}>Magnification</Typography>
            <SettingsSliderControl value={dockMagnification} onChange={onDockMagnificationChange} marks={DOCK_MAGNIFICATION_MARKS} aria-label="Dock magnification" />
          </Box>
        </Box>
      </Paper>
    </Stack>
  )
}
